var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInverted1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 36,
    height: 36,
    transform: "translate(139.866 4189.866)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-139.866 -4189.866)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-quote",
    transform: "translate(140 4192.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M60.55,83.052c.047-.693.09-1.385.141-2.081a27.261,27.261,0,0,1,1.06-6.233,15.25,15.25,0,0,1,4.242-6.568,20.231,20.231,0,0,1,6.027-3.881,1.706,1.706,0,0,1,2.344.851c.469.945.927,1.9,1.363,2.86a1.7,1.7,0,0,1-.895,2.373A13.818,13.818,0,0,0,71.514,72.4a9.172,9.172,0,0,0-2.936,5.14c-.166.747-.252,1.511-.361,2.269a8.494,8.494,0,0,0,0,1.01H73.39a1.749,1.749,0,0,1,1.915,1.9V93.66a1.772,1.772,0,0,1-1.933,1.93H62.461A1.89,1.89,0,0,1,60.528,94.2Z",
    transform: "translate(-60.528 -64.104)",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M102.312,80.82h5.436a1.713,1.713,0,0,1,1.8,1.778V93.78a1.72,1.72,0,0,1-1.634,1.8,2.781,2.781,0,0,1-.361,0H96.764a1.777,1.777,0,0,1-1.987-1.973c0-3.3,0-6.6.018-9.9a40.812,40.812,0,0,1,.588-6.687,15.665,15.665,0,0,1,5.515-9.454,21.1,21.1,0,0,1,5.262-3.246,1.731,1.731,0,0,1,2.438.894q.649,1.331,1.284,2.665a1.714,1.714,0,0,1-.909,2.5,12.123,12.123,0,0,0-3.766,2.467,9.558,9.558,0,0,0-2.543,5.2C102.492,78.952,102.427,79.872,102.312,80.82Z",
    transform: "translate(-74.38 -64.108)",
    fill: "#7b7b7b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverted1);
export default __webpack_public_path__ + "static/media/inverted1.90e7bb7db945fcd39797a89e1cbfc151.svg";
export { ForwardRef as ReactComponent };